import { MutableRefObject, forwardRef, useImperativeHandle } from 'react'

import Icons from 'atoms/Icons'
import { HStack, Menu, Pressable, Text, useDisclose, Spinner } from 'native-base'

type DropdownFormProps = {
  label: string
  renderItems: JSX.Element
  maxH?: number
  isDisabled: boolean
  isLoading?: boolean
  ref?: MutableRefObject<any>
}

export type DropdownFormRefProps = {
  open: () => void
  close: () => void
}

export const DropdownForm = forwardRef<DropdownFormRefProps, DropdownFormProps>(
  ({ label, maxH = 400, renderItems, isDisabled, isLoading, ...props }, ref) => {
    const { isOpen, onClose, onOpen } = useDisclose(false)

    useImperativeHandle(
      ref,
      () => {
        return {
          open: onOpen,
          close: onClose
        }
      },
      [onClose, onOpen]
    )

    return (
      <>
        <Menu
          isOpen={isOpen}
          placement={undefined}
          onClose={onClose}
          minH={100}
          flex={0}
          mt={4}
          py={4}
          maxH={400}
          w="100%"
          minW={500}
          bgColor="white"
          borderRadius={20}
          {...props}
          trigger={(triggerProps) => {
            delete triggerProps.onPress

            return (
              <Pressable
                onPress={onOpen}
                {...triggerProps}
                isDisabled={isDisabled}
                _disabled={{ opacity: 0.6 }}>
                <HStack
                  h="56px"
                  py={3}
                  px={4}
                  space={2}
                  justifyContent="space-between"
                  alignItems="center"
                  backgroundColor="gray.30"
                  borderRadius="40px">
                  <Text color="gray.400" fontSize="16px" lineHeight="24px">
                    {label}
                  </Text>
                  {isLoading ? (
                    <Spinner />
                  ) : (
                    <Icons.Dropdown needsCenter size={6} color="gray.700" />
                  )}
                </HStack>
              </Pressable>
            )
          }}>
          {renderItems}
        </Menu>
      </>
    )
  }
)
